var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHrStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 286,
    height: 183,
    viewBox: "0 0 286 183",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442",
    transform: "translate(-275 -331)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 65.5,
    cy: 65.5,
    r: 65.5,
    transform: "translate(330 331)",
    fill: "#25556e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_192",
    "data-name": "Ellipse 192",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(279 434)",
    fill: "#3a8814"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_193",
    "data-name": "Ellipse 193",
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    transform: "translate(275 383)",
    fill: "#3a8814"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    cx: 45,
    cy: 46.5,
    rx: 45,
    ry: 46.5,
    transform: "translate(471 341)",
    fill: "#fdbb1d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_196",
    "data-name": "Ellipse 196",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(423 462)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_197",
    "data-name": "Ellipse 197",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(298 349)",
    fill: "#e96a24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_195",
    "data-name": "Ellipse 195",
    cx: 24.5,
    cy: 25,
    rx: 24.5,
    ry: 25,
    transform: "translate(452 432)",
    fill: "#fdbb1d"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Transit",
    transform: "translate(380 402)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Transit")), /*#__PURE__*/React.createElement("text", {
    id: "Charging",
    transform: "translate(496 391)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Charging")), /*#__PURE__*/React.createElement("text", {
    id: "Park_",
    "data-name": "Park \\u2026",
    transform: "translate(285 409)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Park \u2026")), /*#__PURE__*/React.createElement("text", {
    id: "Con_",
    "data-name": "Con \\u2026",
    transform: "translate(463 461)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Con \u2026")), /*#__PURE__*/React.createElement("text", {
    id: "Complete",
    transform: "translate(296 478)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Complete")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrStatus);
export default __webpack_public_path__ + "static/media/hr_status.489f2cb2838f9a21200518dc94bc84fb.svg";
export { ForwardRef as ReactComponent };